module.exports = __webpack_public_path__ + "static/media/signup-page-freelancer-2.dec1165d.webp";